/**
 * The app's CueQueue singleton, bound to `presentation.cueBusy`. Scene code registers handlers
 * here (`cueQueue.register('cardPlayed', ...)`); audio/HUD/announcer attach `onStart`.
 */
import { store } from '../store/store';
import { CueQueue, DEFAULT_HOLD_UNTIL_HANDLED } from './CueQueue';

export const cueQueue = new CueQueue({
  setBusy: (busy) => {
    if (store.getState().presentation.cueBusy !== busy) store.getState().setPresentation({ cueBusy: busy });
  },
  // This is the one queue a scene really does register handlers on, so it is the one that should
  // wait for them. The class itself holds nothing by default — a bare `new CueQueue()` in a test
  // would otherwise sit for ten seconds waiting for a handler nobody was going to add.
  holdUntilHandled: DEFAULT_HOLD_UNTIL_HANDLED,
});
